import React from "react";
import Card from "components/card";

const CardItem = (props) => {
  const { extra, icon, title, titleClass, children, cardMenu, withHeader=true } = props;
  return (
    <Card extra={`p-0 rounded-[30px] border border-white/70 dark:border-white/50 ${extra}`}>
      {withHeader && 
      <div className="relative flex flex-row justify-between h-[66px]">
        <div className="flex items-center card-header-title z-30">
          <div className="absolute w-full">
            <div className="absolute top-[-33px] right-[-15px]">
              <div className="curved-corner-topright"/>
            </div>
            <div className="absolute bottom-[-63px] left-[-15px]">
              <div className="curved-corner-bottomleft"/>
            </div>
          </div>
     
          <div className="flex h-9 w-9 items-center justify-center rounded-full bg-lightPrimary dark:bg-darkPrimary">
            {icon}
          </div>
          <h4 className={`ml-4 card-title ${titleClass}`}>
            {title}
          </h4>
        </div>
        {cardMenu}
      </div>
      }
      <div className="h-full w-full relative ">
          {children}
      </div>
    </Card>
  );
};

export default CardItem;
